module.exports = __webpack_public_path__ + "static/media/badge-google-play.19a94b1e.png";